module.exports = __webpack_public_path__ + "media/images/help/create-system-fbce7b8e095b974595a932bffa53d47d.png";